import { GridFilterItem, GridSortItem } from '@mui/x-data-grid-pro';

import { OrderSettings, QueryOption } from '../@types';
import { httpClient, HttpMethod } from './http-client';
import { ReplenishmentConfig, ReplenishmentConfigListResponse, ReplenishmentReportFilters, ReplenishmentReportListResponse } from '../@types/replenishmentConfig.type';
import { isNotArrayEmpty } from '../utils/array-utils';

export const getAllReplenishmentConfigs = (queryOptions: QueryOption): Promise<ReplenishmentConfigListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/replenishmentConfig?limit=${pageSize}&page=${page + 1}`;

  if (sortModel && isNotArrayEmpty(sortModel as GridSortItem[], 0)) {
    url += `&order_by=${sortModel[0]?.field}&order_direction=${sortModel[0]?.sort}`;
  }

  filterModel?.items?.forEach((filter: GridFilterItem) => {
    url += `&${filter?.field}=${filter?.operator},${filter.value}`;
  });

  return httpClient<ReplenishmentConfigListResponse>(url, HttpMethod.Get);
};

export const createReplenishmentConfig = (replenishmentConfig: ReplenishmentConfig): Promise<ReplenishmentConfig> => {
  return httpClient<ReplenishmentConfig>('/replenishmentConfig', HttpMethod.Post, replenishmentConfig);
};

export const getReplenishmentConfigById = (id: number): Promise<ReplenishmentConfig> => {
  return httpClient<ReplenishmentConfig>(`/replenishmentConfig/${id}`, HttpMethod.Get);
};

export const updateReplenishmentConfig = (id: number, replenishmentConfig: ReplenishmentConfig): Promise<ReplenishmentConfig> => {
  return httpClient<ReplenishmentConfig>(`/replenishmentConfig/${id}`, HttpMethod.Put, replenishmentConfig);
};

// when isReport=true (get all replenishment report data)
export const getAllReplenishmentReports = (limit: number, page: number, orderBy?: OrderSettings, customFilters?: ReplenishmentReportFilters): Promise<ReplenishmentReportListResponse> => {
  const replenishmentConfig = {
    limit: limit,
    page: page + 1,
    order_by: orderBy,
    customFilters: customFilters
  };
  return httpClient<ReplenishmentReportListResponse>('/replenishmentReport', HttpMethod.Post, replenishmentConfig);
};
